import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Portfolio() {

  const data = [
    {
      name: "Imagine",
      img: require("../../assets/12.jpg"),
      insta_link: "https://www.instagram.com/isuzu.uz/",
      title: "SAMAUTOning Toshkendagi filiali"
    },
    {
      name: "Gallery",
      img: require("../../assets/1.png"),
      insta_link: " https://www.instagram.com/gallery_com/",
      title: "Arxitektura va design studio"
    },
    {
      name: "Vikron",
      img: require("../../assets/2.jpg"),
      insta_link: "https://www.instagram.com/vikron_uz/",
      title: "Avtomobillarga lak va emal sotuvchi magazin"
    },
    {
      name: "Azimut Sermersan",
      img: require("../../assets/3.jpg"),
      insta_link: "https://www.instagram.com/azimutsirmersan_tashkent/",
      title: "Mramor toshlari"
    },
    {
      name: "Idealdent",
      img: require("../../assets/4.jpg"),
      insta_link: "https://www.instagram.com/ideal_dent_lab/",
      title: "Zub texnik"
    },
    {
      name: "Stirka shtor",
      img: require("../../assets/6.png"),
      insta_link: "https://www.instagram.com/stirkashtor.uz/",
      title: "Parda yuvish" 
    },
    {
      name: "Aya sofya",
      img: require("../../assets/5.png"),
      insta_link: "https://www.instagram.com/ayasofya.uz/",
      title: "Turkcha lokum" 
    },
    {
      name: "Lesel",
      img: require("../../assets/7.jpg"),
      insta_link: "https://www.instagram.com/lesel.uz/",
      title: "Markiz, avtomatik va rolikli eshiklar"
    },
    {
      name: "Noe Classica",
      img: require("../../assets/8.png"),
      insta_link: "https://www.instagram.com/neoclassic_uz/",
      title: "Parda tikish" 
    },
    {
      name: "Stirka uz",
      img: require("../../assets/9.jpg"),
      insta_link: "https://www.instagram.com/stirka_uz/",
      title: "Gilam, bruschatka, avtosalon, mebel va oyna yuvish kompanyasi"
    },
    {
      name: "Petrol exclusive",
      img: require("../../assets/10.jpg"),
      insta_link: " https://www.instagram.com/petrol.exclusive/ ",
      title: "Yonilg'i quyish shaxobchasi"
    },
    {
      name: "Luxclean",
      img: require("../../assets/11.jpg"),
      insta_link: " https://www.instagram.com/luxclean.uz/",
      title: "Gilam, bruschatka, avtosalon, mebel va oyna yuvish kompanyasi"
    },
    {
      name: "Kerry",
      img: require("../../assets/kerry.jpg"),
      insta_link: " https://www.instagram.com/kerry_uz/",
      title: "Mebel do'kon"
    },
  ]
  return (
    <Container id="portfolio">
      <h2>Mening portfoliom</h2>

      <div className="projects">

      {
        data.map((item, index) => (
          <ScrollAnimation key={index} animateIn="flipInX">
            <a target='_blank' href={item.insta_link}>
              <div className="project">
                <div className="body">
                    <h3>{item.name}</h3>
                  <img src={item.img} className='portfolio-logo' style={{width:"100%"}} alt="" />
                </div>
                <footer>
                <ul className="tech-list">
                    <li>{item.title}</li>
                  </ul>
                </footer>
              </div>
            </a>
          </ScrollAnimation>
        ))
      }

      </div>
    </Container>
  );
}